export const elementId = 'js-vacancies-filter'
export const initialQueryLength = 20
export const proceedingQueryLength = 20
